module.exports = __webpack_public_path__ + "static/media/lore_square.287e5a6a.jpg";